// extracted by mini-css-extract-plugin
export default {"copyData":"CopyButton_copyData__k4i5G"};